<template>
  <ts-tab-panes-horizontal name="gTab">
    <ts-tab-pane-horizontal :class="{
      'mt-1':
        (!safeSubCategories || safeSubCategories.length === 0) &&
        (!safeCategories || safeCategories.length === 0)
    }">
      <div class="product-container" v-for="(pro, index) in safeProducts" :key="'product-' + index">
        <div class="product-wrapper">
          <a class="product" v-b-modal.modalPosItem @click="$emit('select-product', pro.product_id)">
            <img class="img" v-lazy="{
              src: pro.photo
                ? pro.photo
                : require('@/assets/default-product.jpg'),
              error: require('@/assets/default-product.jpg')
            }" />

            <!-- Floating Quantity Controls -->
            <div v-if="getProductQuantity(pro.product_id) > 0" class="quantity-controls" @click.stop
              @mouseenter="cancelHide(pro.product_id)" @mouseleave="startHideTimer(pro.product_id)">
              <!-- Show expanded controls when hovering or recently interacted -->
              <div v-if="shouldShowExpandedControls(pro.product_id)" class="quantity-controls-expanded">
                <!-- Delete button (trash) when quantity is 1 -->
                <button v-if="getProductQuantity(pro.product_id) === 1" class="qty-button qty-button-delete"
                  @click="$emit('remove-product', pro.product_id)">
                  <i class="fas fa-trash"></i>
                </button>
                <!-- Decrease button when quantity > 1 -->
                <button v-else class="qty-button qty-button-decrease"
                  @click="$emit('decrease-quantity', pro.product_id)">
                  <i class="fas fa-minus"></i>
                </button>

                <span class="qty-display">{{
                  getProductQuantity(pro.product_id)
                }}</span>

                <button class="qty-button qty-button-increase" @click="$emit('increase-quantity', pro.product_id)">
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <!-- Compact quantity display when not expanded -->
              <div v-else class="quantity-display-compact" @click="showControls(pro.product_id)">
                <span class="qty-number">{{
                  getProductQuantity(pro.product_id)
                }}</span>
              </div>
            </div>

            <!-- Add Button (shown when quantity is 0) -->
            <div v-else class="add-btn-container" @click.stop>
              <button class="add-btn" @click="handleAddProduct(pro.product_id)">
                <i class="fas fa-plus"></i>
              </button>
            </div>

            <!-- Add Button (shown when quantity is 0) -->
            <div v-else class="add-btn-container" @click.stop>
              <button class="add-btn" @click="handleAddProduct(pro.product_id)">
                <i class="fas fa-plus"></i>
              </button>
            </div>

            <div class="text">
              <div class="title ts-whitespace-no-wrap">
                {{
                  pro.product_name_kh
                    ? pro.product_name_kh
                    : pro.product_name_en
                }}
              </div>
              <div class="desc ts-text-gray-700 ts-whitespace-no-wrap">
                {{ pro.product_name_en }}
              </div>
              <div class="price">
                <span class="text-info">{{ pro.barcode }}</span>
                <span class="pull-right ts-text-blue-600">
                  {{ defaultCrrency }}
                  {{ defaultPrice(pro.product_id, dataSend.guest_level_id) }}
                </span>
              </div>
            </div>
            <div class="tag-container">
              <span v-if="
                getPromotionDiscountDisplay(
                  pro.product_id,
                  saleCodeByDefaultUom(pro.product_id).unit_of_measure.uom_id,
                  tableSelected.guest_level_id
                )
              " class="multi-tag">
                {{
                  getPromotionDiscountDisplay(
                    pro.product_id,
                    saleCodeByDefaultUom(pro.product_id).unit_of_measure.uom_id,
                    tableSelected.guest_level_id
                  )
                }}
              </span>
              <span v-if="
                getPromotionBuyItemFreeItem(
                  pro.product_id,
                  saleCodeByDefaultUom(pro.product_id).unit_of_measure.uom_id
                )
              " class="multi-tag-free-item">
                {{
                  getPromotionBuyItemFreeItemDisplay(
                    pro.product_id,
                    saleCodeByDefaultUom(pro.product_id)
                  )
                }}
              </span>
            </div>
          </a>
        </div>
      </div>
    </ts-tab-pane-horizontal>

    <ts-tab-pane-horizontal v-for="(c, index) in safeProductCategory" :key="'category-' + index">
      <div class="product-container" v-for="(pro, index) in safeProducts" :key="'product-' + index">
        <div class="product-wrapper">
          <a class="product" v-b-modal.modalPosItem @click="$emit('select-product', pro.product_id)">
            <img class="img" v-lazy="{
              src: pro.photo
                ? pro.photo
                : require('@/assets/default-product.jpg'),
              error: require('@/assets/default-product.jpg')
            }" />

            <!-- Floating Quantity Controls -->
            <div v-if="getProductQuantity(pro.product_id) > 0" class="quantity-controls" @click.stop
              @mouseenter="cancelHide(pro.product_id)" @mouseleave="startHideTimer(pro.product_id)">
              <!-- Show expanded controls when hovering or recently interacted -->
              <div v-if="shouldShowExpandedControls(pro.product_id)" class="quantity-controls-expanded">
                <!-- Delete button (trash) when quantity is 1 -->
                <button v-if="getProductQuantity(pro.product_id) === 1" class="qty-button qty-button-delete"
                  @click="$emit('remove-product', pro.product_id)">
                  <i class="fas fa-trash"></i>
                </button>
                <!-- Decrease button when quantity > 1 -->
                <button v-else class="qty-button qty-button-decrease"
                  @click="$emit('decrease-quantity', pro.product_id)">
                  <i class="fas fa-minus"></i>
                </button>

                <span class="qty-display">{{
                  getProductQuantity(pro.product_id)
                }}</span>

                <button class="qty-button qty-button-increase" @click="$emit('increase-quantity', pro.product_id)">
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <!-- Compact quantity display when not expanded -->
              <div v-else class="quantity-display-compact" @click="showControls(pro.product_id)">
                <span class="qty-number">{{
                  getProductQuantity(pro.product_id)
                }}</span>
              </div>
            </div>

            <!-- Add Button (shown when quantity is 0) -->
            <div v-else class="add-btn-container" @click.stop>
              <button class="add-btn" @click="handleAddProduct(pro.product_id)">
                <i class="fas fa-plus"></i>
              </button>
            </div>

            <div class="text">
              <div class="title ts-whitespace-no-wrap">
                {{
                  pro.product_name_kh
                    ? pro.product_name_kh
                    : pro.product_name_en
                }}
              </div>
              <div class="desc ts-text-gray-700 ts-whitespace-no-wrap">
                {{ pro.product_name_en }}
              </div>
              <div class="price">
                <span class="text-info">{{ pro.barcode }}</span>
                <span class="pull-right ts-text-blue-600">
                  {{ defaultCrrency }}
                  {{ defaultPrice(pro.product_id, dataSend.guest_level_id) }}
                </span>
              </div>
            </div>
            <div class="tag-container">
              <span v-if="
                getPromotionDiscountDisplay(
                  pro.product_id,
                  saleCodeByDefaultUom(pro.product_id).unit_of_measure.uom_id,
                  tableSelected.guest_level_id
                )
              " class="multi-tag">
                {{
                  getPromotionDiscountDisplay(
                    pro.product_id,
                    saleCodeByDefaultUom(pro.product_id).unit_of_measure.uom_id,
                    tableSelected.guest_level_id
                  )
                }}
              </span>
              <span v-if="
                getPromotionBuyItemFreeItem(
                  pro.product_id,
                  saleCodeByDefaultUom(pro.product_id).unit_of_measure.uom_id
                )
              " class="multi-tag-free-item">
                {{
                  getPromotionBuyItemFreeItemDisplay(
                    pro.product_id,
                    saleCodeByDefaultUom(pro.product_id)
                  )
                }}
              </span>
            </div>
          </a>
        </div>
      </div>
    </ts-tab-pane-horizontal>
  </ts-tab-panes-horizontal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductGrid',
  props: {
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    dataSend: {
      type: Object,
      default: function () {
        return {}
      }
    },
    locale: String,
    productCategory: {
      type: Array,
      default: function () {
        return []
      }
    },
    subCategories: {
      type: Array,
      default: function () {
        return []
      }
    },
    categories: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      expandedControls: {}, // reactive object
      controlTimers: {}
    }
  },
  computed: {
    ...mapGetters('restaurantSale/customerOrder', [
      'defaultPrice',
      'saleCodeByDefaultUom',
      'getPromotionDiscountDisplay',
      'getPromotionBuyItemFreeItem'
    ]),
    defaultCrrency() {
      const settings = this.$store.state.restaurantSale.customerOrder
        .systemSettings
      return settings && settings.default_currency
        ? settings.default_currency
        : ''
    },
    safeProductCategory() {
      return this.productCategory || []
    },
    safeProducts() {
      return this.products || []
    },
    safeSubCategories() {
      return this.subCategories || []
    },
    safeCategories() {
      return this.categories || []
    },
    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
  },
  methods: {
    getPromotionBuyItemFreeItemDisplay(product_id, saleCode) {
      const promotion = this.getPromotionBuyItemFreeItem(
        product_id,
        saleCode ? saleCode.unit_of_measure.uom_id : 0
      )
      return promotion ? promotion.promotion_name : ''
    },
    getProductQuantity(productId) {
      // Ensure products exists and is an array
      if (!this.dataSend.products || !Array.isArray(this.dataSend.products)) {
        return 0
      }

      // Filter all records with the same product_id and sum their quantities
      const totalQuantity = this.dataSend.products
        .filter(item => item.product_id === productId && (this.tableSelected.linked_keys.length > 0 ? item.ref_table_id == null : true == true))
        .reduce((sum, item) => sum + (item.quantity || 0), 0)

      return totalQuantity
    },

    shouldShowExpandedControls(productId) {
      return this.expandedControls.has(productId)
    },
    showControls(productId) {
      this.$set(this.expandedControls, productId, true)
      this.cancelHide(productId) // clear any old timer
    },

    startHideTimer(productId) {
      this.cancelHide(productId)
      this.controlTimers[productId] = setTimeout(() => {
        this.hideControls(productId)
      }, 2000)
    },

    cancelHide(productId) {
      if (this.controlTimers[productId]) {
        clearTimeout(this.controlTimers[productId])
        this.$delete(this.controlTimers, productId)
      }
    },

    hideControls(productId) {
      this.cancelHide(productId)
      this.$delete(this.expandedControls, productId)
    },

    shouldShowExpandedControls(productId) {
      return !!this.expandedControls[productId]
    },
    handleAddProduct(productId) {
      this.$emit('add-product', productId)
      // Show expanded controls for 3 seconds after adding
      this.showControls(productId)
    }
  },
  beforeDestroy() {
    // Clean up timers
    Object.values(this.controlTimers).forEach(timer => clearTimeout(timer))
  }
}
</script>

<style scoped>
.product-wrapper {
  position: relative;
}

.tag-container {
  color: #fff;
  position: absolute;
  z-index: 3;
  top: 16px;
  left: 0;
  line-height: 24px;
  font-size: 0.7rem;
  font-weight: 600;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  text-transform: uppercase;
}

.tag-container .multi-tag {
  height: 24px;
  background-color: #d70f64;
  padding: 0 10px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-align-self: flex-start;
  -ms-flex-item-align: start;
  align-self: flex-start;
  max-width: 232px;
}

.tag-container .multi-tag-free-item {
  height: 24px;
  background-color: #fd7e14;
  padding: 0 10px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-align-self: flex-start;
  -ms-flex-item-align: start;
  align-self: flex-start;
  max-width: 232px;
}

/* Floating Quantity Controls */
.quantity-controls {
  position: absolute;
  top: 95px;
  right: 6px;
  z-index: 10;
  padding: 2px 2px !important;
}

.quantity-controls-expanded {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  animation: expandIn 0.2s ease-out;
}

.quantity-display-compact {
  background: #007bff;
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  padding-top: 4px;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.2s ease;
}

.quantity-display-compact:hover {
  background: #016bdd;
  transform: scale(1.05);
}

.qty-number {
  font-weight: 600;
  font-size: 12px;
}

.qty-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  transition: all 0.2s ease;
  margin: 0 2px;
}

.qty-button-increase {
  background: #00acac;
  color: white;
}

.qty-button-increase:hover {
  background: #028888;
  transform: scale(1.1);
}

.qty-button-decrease {
  background: #f59c1a;
  color: #212529;
  color: white;
}

.qty-button-decrease:hover {
  background: #f5980e;
  transform: scale(1.1);
  color: white;
}

.qty-button-delete {
  background: #dc3545;
  color: white;
}

.qty-button-delete:hover {
  background: #c82333;
  transform: scale(1.1);
}

.qty-display {
  min-width: 20px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  margin: 0 6px;
  color: #333;
}

/* Add Button for items with 0 quantity */
.add-btn-container {
  position: absolute;
  top: 95px;
  right: 6px;
  z-index: 10;
}

.add-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  color: #007bff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.2s ease;
}

.add-btn:hover {
  background: #f2f2f2;
  transform: scale(1.05);
  color: #0978f0;
}

.add-btn:active {
  transform: scale(0.95);
}

/* Animation for expanding controls */
@keyframes expandIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Ensure the product card doesn't interfere with floating controls */
.product {
  position: relative;
}
</style>
